export const tr = {
    'rejected-on-moderation': 'Moderasyondan geçmedi'
};
